/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */

import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Table, Labelbox, Button, Modal } from "../../components";
import PhoneInput from "../../components/PhoneInput";
import { normalizeToE164 } from "../../utils/phoneUtils";
import { buildEmployeeAdminFormPartialPayload } from "../../utils/employeeProfileUpdate";
import "./employee.scss";
import ValidationLibrary from "../../utils/validationfunction";
import Grid from "@material-ui/core/Grid";
import { EMPLOYEE_ACTION, MASTER_ACTION } from "../../redux/action";
import {
  Toaster,
  dateFormatter,
  encryptPassword,
  decryptPassword,
  dropdownNameWithEmail,
} from "../../utils/common";
import { header } from "./defaultState";
import ClientTransfer from "../client_transfer";
import SearchIcon from "@material-ui/icons/Search";
import { AddCircleOutlineOutlined, ArrowBack } from "@material-ui/icons";

const Employee = () => {
  const defaultState = {
    first_name: {
      labelname: "First Name",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    last_name: {
      labelname: "Last Name",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    company_employee_id: {
      labelname: "Company Employee ID",
      value: "",
      error: null,
      errmsg: null,
      placeholder: "e.g. FT-1042",
    },
    email: {
      labelname: "Email Address",
      value: "",
      validation: [
        { name: "required" },
        { name: "emailNew" },
        { name: "finloEmail" },
      ],
      error: null,
      errmsg: null,
      placeholder: "name@finlotax.com or name@numerotax.com",
    },
    password: {
      labelname: "Password",
      password: true,
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    phone: {
      labelname: "Work Phone",
      value: "",
      validation: [{ name: "mobile" }],
      error: null,
      errmsg: null,
    },
    role_id: {
      labelname: "Role",
      value: "",
      type: "select",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    address_1: {
      labelname: "Address 1",
      value: "",
      //validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    address_2: {
      labelname: "Address 2",
      value: "",
      // validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    country_id: {
      labelname: "Country",
      value: "",
      type: "select",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    state_id: {
      labelname: "State",
      type: "select",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    city_id: {
      labelname: "City",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    zipcode: {
      labelname: "Zip Code",
      value: "",
      //validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    doj: {
      labelname: "Date of joining",
      type: "datepicker",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    designation: {
      labelname: "Designation",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    branch_office: {
      labelname: "Branch Office",
      type: "select",
      value: "",
      dropdown: [
        { id: "Sunnyvale - USA", value: "Sunnyvale - USA" },
        { id: "Pleasanton - USA", value: "Pleasanton - USA" },
        { id: "Bangalore - India", value: "Bangalore - India" },
        { id: "Sirsi - India", value: "Sirsi - India" },
      ],
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    team: {
      labelname: "Team",
      type: "select",
      value: "",
      dropdown: [
        { id: "Individual", value: "Individual Team" },
        { id: "Business", value: "Business Team" },
        { id: "Both", value: "Both" },
      ],
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    meeting_link: {
      labelname: "Meeting Link",
      value: "",
      validation: [
        { name: "required" },
        {
          name: "regex",
          params: "^https?:\\/\\/.+",
          msg: "Enter a valid URL starting with http:// or https://",
        },
      ],
      error: null,
      errmsg: null,
      placeholder: "https://meet.google.com/... or Zoom/Teams link",
    },
    status: {
      labelname: "Status",
      type: "select",
      value: 1,
      dropdown: [
        { id: 0, value: "Inactive" },
        { id: 1, value: "Active" },
      ],
      error: null,
      errmsg: null,
    },
  };

  const [editMode, setEditMode] = useState({ mode: false, employee_id: 0 });
  const [fieldConfiguration, setFieldConfiguration] = useState(defaultState);
  const [resetEvent, setResetEvent] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const customRef = useRef(null);
  const employeeEditBaselineRef = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const [showFormView, setShowFormView] = useState(
    location.state?.mode === "edit" || location.state?.mode === "create"
      ? true
      : false,
  );
  const [openTransferPage, setOpenTransferPage] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    employee: null,
  });

  /////************ API DATA PROCESS************////////////
  useEffect(() => {
    dispatch(EMPLOYEE_ACTION.getAllEmployees());
    dispatch(EMPLOYEE_ACTION.getActiveEmployees());
    dispatch(EMPLOYEE_ACTION.getActiveManagers());
  }, [dispatch]);

  const {
    employee: { activeEmployees, activeManagers },
    master,
  } = useSelector((state) => state);

  const employeeDropdown = useCallback(
    (employee_id) => {
      const returnData = [];
      activeEmployees.forEach((data) => {
        if (data.employee_id !== employee_id)
          returnData.push({
            id: data.employee_id,
            value: dropdownNameWithEmail(data),
          });
      });
      return returnData;
    },
    [activeEmployees],
  );

  // Reporting Manager: admins (role_id === 1) and managers (role_id === 2)
  const managerDropdown = useMemo(() => {
    if (!activeEmployees || !Array.isArray(activeEmployees)) return [];
    return activeEmployees
      .filter((data) => data.role_id === 1 || data.role_id === 2)
      .map((data) => ({
        id: data.employee_id,
        value: dropdownNameWithEmail(data),
      }));
  }, [activeEmployees]);

  const newFields = {
    reassigned_id: {
      labelname: "Reassigned To",
      value: "",
      type: "select",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    manager_id: {
      labelname: "Reporting Manager",
      value: "",
      type: "select",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
      dropdown: managerDropdown,
    },
  };

  // Ensure manager dropdown is available on create employee as well
  useEffect(() => {
    setFieldConfiguration((prev) => {
      return {
        ...prev,
        manager_id: {
          ...(prev.manager_id || newFields.manager_id),
          dropdown: managerDropdown,
        },
      };
    });
  }, [managerDropdown]);

  /********* RESPONSE ***********/
  useEffect(() => {
    const delay = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 2000);

    return () => clearTimeout(delay);
  }, [searchQuery]);

  useEffect(() => {
    dispatch(EMPLOYEE_ACTION.getAllEmployees({ search: debouncedSearch }));
  }, [dispatch, debouncedSearch]);

  const {
    employee: { allEmployees },
  } = useSelector((state) => state);

  const tableData = useMemo(() => {
    return allEmployees.map((data) => ({
      firstName: (
        <span className="employee-name-with-status">
          {data.first_name}
          <span
            className={`status-dot ${
              data.status ? "status-active" : "status-inactive"
            }`}
          ></span>
        </span>
      ),
      lastName: data.last_name,
      companyEmployeeId: data.company_employee_id || "—",
      email: data.email,
      phone: data.phone,
      role: data.role,
      doj: dateFormatter(data.doj),
    }));
  }, [allEmployees]);

  const masterSetup = {
    state: "state_id",
    role: "role_id",
    country: "country_id",
  };

  //////////////////
  const masterDataDropdown = () => {
    const mapKeys = Object.keys(masterSetup);
    mapKeys.forEach((data) => {
      if (Array.isArray(masterSetup[data])) {
        masterSetup[data].forEach((sub_data) => {
          if (fieldConfiguration.hasOwnProperty(sub_data)) {
            setFieldConfiguration((prevState) => ({
              ...prevState,
              [sub_data]: {
                ...fieldConfiguration[sub_data],
                dropdown:
                  sub_data === "business_state_id"
                    ? master[sub_data]
                    : master[data],
              },
            }));
          }
        });
      } else {
        if (fieldConfiguration.hasOwnProperty(masterSetup[data])) {
          setFieldConfiguration((prevState) => ({
            ...prevState,
            [masterSetup[data]]: {
              ...fieldConfiguration[masterSetup[data]],
              dropdown: master[data],
            },
          }));
        }
      }
    });
  };

  useEffect(() => {
    masterDataDropdown();
  }, [master, resetEvent]);

  /**
   * @function checkValidation used for validation purpose of input fileds
   * @param {string} data input field data
   * @param {string} key input field name
   */
  function checkValidation(data, key) {
    if (key === "country_id") {
      dispatch(
        MASTER_ACTION.getMasterData({
          name: "state",
          name_type: key === "business_country_id" && "business_state_id",
          id: data,
        }),
      );
    } else if (key === "role_id") {
      // Handle manager_id visibility based on role
      if (data === 1) {
        // Admin role - remove manager_id
        resetFields(false, "manager_id", null);
      } else {
        // Non-admin roles - add manager_id
        resetFields(true, "manager_id", {
          ...newFields.manager_id,
          dropdown: managerDropdown,
        });
      }
    } else if (key === "status" && editMode.mode) {
      const reassignedDropdown = employeeDropdown(editMode.employee_id);
      resetFields(!data, "reassigned_id", {
        ...newFields.reassigned_id,
        dropdown: reassignedDropdown,
      });
    }
    const errorcheck = ValidationLibrary.checkValidation(
      data,
      fieldConfiguration[key].validation,
    );
    const dynObj = {
      ...fieldConfiguration[key],
      value: data,
      error: !errorcheck.state,
      errmsg: errorcheck.msg,
    };

    setFieldConfiguration((prevState) => ({
      ...prevState,
      [key]: dynObj,
    }));
  }

  function resetFields(createProp, key, fieldset) {
    if (createProp) fieldConfiguration[key] = fieldset;
    else if (fieldConfiguration[key]) delete fieldConfiguration[key];
  }

  const handleCancel = () => {
    setFieldConfiguration(defaultState);
    setResetEvent(!resetEvent);
    setEditMode({ mode: false, employee_id: 0 });
    setShowFormView(false);
    employeeEditBaselineRef.current = null;
  };

  /**
   *
   */
  async function onSubmit() {
    const mainvalue = {};
    const targetkeys = Object.keys(fieldConfiguration);
    for (const i in targetkeys) {
      const errorcheck = ValidationLibrary.checkValidation(
        fieldConfiguration[targetkeys[i]].value,
        fieldConfiguration[targetkeys[i]].validation,
      );
      fieldConfiguration[targetkeys[i]].error = !errorcheck.state;
      fieldConfiguration[targetkeys[i]].errmsg = errorcheck.msg;
      mainvalue[targetkeys[i]] = fieldConfiguration[targetkeys[i]].value;
    }
    const filtererr = targetkeys.filter(
      (obj) => fieldConfiguration[obj].error === true,
    );
    if (filtererr.length > 0) {
    } else if (editMode.mode) {
      const partial = buildEmployeeAdminFormPartialPayload(
        fieldConfiguration,
        employeeEditBaselineRef.current || {},
      );

      const passwordValue = fieldConfiguration.password?.value;
      if (
        passwordValue &&
        String(passwordValue).trim() !== "" &&
        String(passwordValue).trim() !== "********"
      ) {
        const baselinePassword =
          decryptPassword(employeeEditBaselineRef.current?.password) || "";
        if (String(passwordValue) !== String(baselinePassword)) {
          partial.password = encryptPassword(passwordValue);
        }
      }

      if (
        Object.prototype.hasOwnProperty.call(partial, "role_id") &&
        Number(partial.role_id) === 1
      ) {
        partial.manager_id = null;
      }

      if (Object.keys(partial).length === 0) {
        Toaster.warning("No changes to save.");
        return;
      }

      const response = await EMPLOYEE_ACTION.insertUpdateEmployee({
        params: partial,
        insertUpdateFlag: 1,
        employee_id: editMode.employee_id,
      });
      if (response.status === 200) {
        Toaster.success("Employee updated successfully");
        setShowFormView(false);
      } else {
        Toaster.error("Error occurred while updating the employee");
      }
      dispatch(EMPLOYEE_ACTION.getAllEmployees());
      dispatch(EMPLOYEE_ACTION.getActiveEmployees());
      dispatch(EMPLOYEE_ACTION.getActiveManagers());
      handleCancel();
    } else {
      const params = {};
      targetkeys.forEach((data) => {
        let value = fieldConfiguration[data].value;

        // Normalize phone numbers to E.164 format before sending to backend
        if (data === "phone" && value) {
          const normalizedPhone = normalizeToE164(value);
          if (normalizedPhone) {
            value = normalizedPhone;
          } else {
            value = value.toString().trim();
            if (value && !value.startsWith("+")) {
              value = `+${value}`;
            }
          }
        }

        params[data] = value;
      });

      if (!Object.prototype.hasOwnProperty.call(params, "manager_id")) {
        params.manager_id = null;
      }

      const response = await EMPLOYEE_ACTION.insertUpdateEmployee({
        params: { ...params, password: encryptPassword(params.password) },
        insertUpdateFlag: 0,
        employee_id: editMode.employee_id,
      });
      if (response.status === 200) {
        Toaster.success("Employee created successfully");
        setShowFormView(false);
      } else {
        Toaster.error("Error occurred while creating the employee");
      }
      dispatch(EMPLOYEE_ACTION.getAllEmployees());
      dispatch(EMPLOYEE_ACTION.getActiveEmployees());
      dispatch(EMPLOYEE_ACTION.getActiveManagers());

      handleCancel();
    }
    setFieldConfiguration((prevState) => ({
      ...prevState,
    }));
  }

  const openDeleteDialog = (employee) => {
    setDeleteDialog({
      open: true,
      employee,
    });
  };

  const closeDeleteDialog = () => {
    setDeleteDialog({
      open: false,
      employee: null,
    });
  };

  // placeholder – you will wire backend later
  const confirmDelete = () => {
    closeDeleteDialog();
  };

  const normalizeGetEmployeePayload = (payload) => {
    if (payload == null) return {};
    if (Array.isArray(payload)) {
      const first = payload[0];
      return first && typeof first === "object" ? first : {};
    }
    if (typeof payload === "object") return payload;
    return {};
  };

  const buildEditFieldConfiguration = (selectedData) => {
    const actionFieldConfiguration = JSON.parse(JSON.stringify(defaultState));

    Object.keys(defaultState).forEach((key) => {
      if (key === "password") {
        const decrypted = decryptPassword(selectedData.password);
        actionFieldConfiguration[key].value = decrypted || "********";
      } else if (key === "email") {
        actionFieldConfiguration[key].value = selectedData.email;
      } else if (key === "phone") {
        let phoneValue = selectedData.phone || "";
        if (phoneValue && !phoneValue.startsWith("+")) {
          phoneValue = `+${phoneValue}`;
        }
        actionFieldConfiguration[key].value = phoneValue;
      } else if (key === "meeting_link") {
        actionFieldConfiguration[key].value = selectedData.meeting_link || "";
        actionFieldConfiguration[key].validation = [
          {
            name: "regex",
            params: "^https?:\\/\\/.+",
            msg: "Enter a valid URL starting with http:// or https://",
          },
        ];
      } else if (key === "country_id") {
        actionFieldConfiguration[key].value = selectedData.country_id || "";
        dispatch(
          MASTER_ACTION.getMasterData({
            name: "state",
            id: selectedData.country_id,
          }),
        );
      } else if (key === "city_id") {
        actionFieldConfiguration[key].value = selectedData[key] || "";
      } else if (key === "zipcode") {
        actionFieldConfiguration[key].value = selectedData[key] || "";
      } else if (selectedData.hasOwnProperty(key)) {
        actionFieldConfiguration[key].value = selectedData[key] || "";
      } else {
        actionFieldConfiguration[key].value = "";
      }
    });

    delete actionFieldConfiguration.manager_id;
    delete actionFieldConfiguration.reassigned_id;

    const empIdForDropdown =
      selectedData.employee_id ??
      selectedData.employeeID ??
      selectedData.id;

    if (selectedData.role_id !== 1) {
      actionFieldConfiguration.manager_id = {
        ...newFields.manager_id,
        value: selectedData.manager_id || "",
        dropdown: managerDropdown,
      };
    }

    if (!selectedData.status) {
      actionFieldConfiguration.reassigned_id = {
        ...newFields.reassigned_id,
        value: selectedData.reassigned_id || "",
        dropdown: employeeDropdown(empIdForDropdown),
      };
    }

    return actionFieldConfiguration;
  };

  const onAction = async (type, actionData, index) => {
    const rowFromList = allEmployees[index];
    if (!rowFromList) return;

    if (type === "edit") {
      customRef.current?.scrollIntoView({ behavior: "smooth" });
      setShowFormView(true);

      const employeeId =
        rowFromList.employee_id ??
        rowFromList.employeeID ??
        rowFromList.id;
      if (employeeId == null || employeeId === "") {
        Toaster.error("Missing employee id.");
        return;
      }

      setEditMode({
        mode: true,
        employee_id: employeeId,
      });

      let record = rowFromList;
      try {
        const payload = await dispatch(
          EMPLOYEE_ACTION.getEmployee(String(employeeId)),
        ).unwrap();
        const detail = normalizeGetEmployeePayload(payload);
        if (detail && Object.keys(detail).length > 0) {
          record = { ...rowFromList, ...detail };
        }
      } catch (err) {
        Toaster.error(
          err?.message ||
            err?.toString?.() ||
            "Could not load employee details.",
        );
      }

      setFieldConfiguration(buildEditFieldConfiguration(record));
      employeeEditBaselineRef.current = { ...record };
      return;
    }

    if (type === "delete") {
      openDeleteDialog(rowFromList);
    }
  };

  return (
    <div className="employee-page-wrapper" style={{ paddingTop: 28 }}>
      <div className="employee-page-content">
        {/* Page Header */}
        <div
          className="employee-page-header"
          style={{
            marginBottom: 20,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="TitlePane" style={{ fontSize: "24px" }}>
            {editMode.mode
                ? "Edit Employee"
                : ""}
          </div>
          <div style={{ display: "flex", gap: "12px" }}>
            {openTransferPage ? (
              <Button
                className="timesheet-add-row-btn"
                variant="outline"
                icon={<ArrowBack />}
                text="Back"
                large
                handleClick={() => setOpenTransferPage(false)}
              />
            ) : showFormView ? (
              <Button
                className="timesheet-add-row-btn"
                variant="outline"
                icon={<ArrowBack />}
                text="Back"
                large
                handleClick={() => {
                  setShowFormView(false);
                  setEditMode({ mode: false, employee_id: 0 });
                  setFieldConfiguration(defaultState);
                }}
              />
            ) : (
              <>
                <Button
                  variant="outline"
                  text="Transfer Clients"
                  large
                  handleClick={() => setOpenTransferPage(true)}
                />
                <Button
                  variant="outline"
                  icon={<AddCircleOutlineOutlined />}
                  text="Create Employee"
                  handleClick={() => setShowFormView(true)}
                />
              </>
            )}
          </div>
        </div>
        {/* Create Employee Form Section */}
        {openTransferPage ? (
          <div style={{ width: "100%" }}>
            <ClientTransfer />
          </div>
        ) : showFormView && (
          <div className="employee-form-panel" ref={customRef}>
            <h3 className="employee-form-title">
              {/* {!editMode.mode ? "Create" : "Edit"} Employee */}
            </h3>
            <Grid container spacing={2}>
              {Object.keys(fieldConfiguration).map((data, index) => {
                if (!editMode.mode && data === "status") {
                  return null;
                }
                const isRequired = fieldConfiguration[data]?.validation?.some(
                  (rule) => rule.name === "required",
                );
                // Use PhoneInput for phone field, Labelbox for others
                if (data === "phone") {
                  return (
                    <Grid item xs={12} md={3} sm={6} key={`data${index}`}>
                      <PhoneInput
                        labelname={fieldConfiguration[data].labelname}
                        value={fieldConfiguration[data].value || ""}
                        onChange={(value) => {
                          // Ensure value has + prefix
                          const phoneValue =
                            value && !value.startsWith("+")
                              ? `+${value}`
                              : value || "";
                          checkValidation(phoneValue, data);
                        }}
                        error={fieldConfiguration[data].error}
                        errmsg={fieldConfiguration[data].errmsg}
                        disabled={fieldConfiguration[data].disabled}
                        required={isRequired}
                        placeholder={fieldConfiguration[data].placeholder}
                      />
                    </Grid>
                  );
                }

                return (
                  <Grid item xs={12} md={3} sm={6} key={`data${index}`}>
                    <Labelbox
                      type={fieldConfiguration[data].type || "text"}
                      labelname={
                        <span>
                          {fieldConfiguration[data].labelname}{" "}
                          {isRequired && (
                            <span style={{ color: "red" }}>*</span>
                          )}
                        </span>
                      }
                      password={fieldConfiguration[data]?.password}
                      dropdown={
                        fieldConfiguration[data]?.type === "select" &&
                        fieldConfiguration[data]?.dropdown
                          ? fieldConfiguration[data]?.dropdown
                          : false
                      }
                      changeData={(e) => checkValidation(e, data)}
                      disabled={fieldConfiguration[data].disabled}
                      value={fieldConfiguration[data].value}
                      error={fieldConfiguration[data].error}
                      errmsg={fieldConfiguration[data].errmsg}
                      placeholder={fieldConfiguration[data].placeholder}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <div className="employee-form-actions">
              <button className="employee-btn-cancel" onClick={handleCancel}>
                Cancel
              </button>
              <button className="employee-btn-create" onClick={onSubmit}>{`${
                editMode.mode ? "Update" : "Create"
              }`}</button>
            </div>
          </div>
        )}
        {/* Employee List Table Section */}
        {!openTransferPage && !showFormView && (
          <div className="employee-table-panel panel">
            <div
              style={{ display: "flex", paddingBottom: "24px" }}
              className="panel-headin"
            >
              <div className="dash-search">
                <SearchIcon className="dash-search-icon" />
                <input
                  type="text"
                  placeholder="Search Employee"
                  aria-label="Search Employee"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <div className="panel-tools">
                {/* <div className="dash-search">
                  <SearchIcon className="dash-search-icon" />
                  <input
                    type="text"
                    placeholder="Search Employee"
                    aria-label="Search Employee"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div> */}
                <div className="employee-status-indicators">
                  <span className="status-indicator">
                    <span className="status-dot status-active"></span>
                    Active
                  </span>
                  <span className="status-indicator">
                    <span className="status-dot status-inactive"></span>
                    Inactive
                  </span>
                </div>
              </div>
            </div>
            <Table
              title=""
              header={header}
              data={tableData}
              aligncss="dashboard-table employee-table"
              className="employee-table-scope"
              actions={["edit"]}
              onActionClick={onAction}
            />
          </div>
        )}{" "}
      </div>{" "}
      {/* Delete employee confirmation modal */}
      <div className="delete-file-modal">
        {deleteDialog.open && (
          <Modal
            title={null}
            open={deleteDialog.open}
            handleClose={closeDeleteDialog}
            className="delete-confirm-modal timesheet-view-modal"
          >
            <div className="delete-confirm">
              <div className="delete-confirm-header">
                <h3>Delete</h3>
                <button
                  type="button"
                  className="delete-confirm-close"
                  onClick={closeDeleteDialog}
                  aria-label="Close"
                >
                  ✕
                </button>
              </div>

              <p className="delete-confirm-text">
                Are you sure want delete this employee?
              </p>

              <div className="delete-confirm-actions">
                <button
                  type="button"
                  className="delete-btn secondary"
                  onClick={closeDeleteDialog}
                >
                  No
                </button>
                <button
                  type="button"
                  className="delete-btn danger"
                  onClick={confirmDelete}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </div>
  );
};
export default Employee;
